import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef } from 'react';
import { describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { cx } from '@elliemae/ds-utilities/utils';
import CheckMark from './elements/CheckMark.js';
import { defaultProps } from './defaultProps.js';
import { checkboxProps } from './props.js';
export { a as CHECKBOX_VARIANT } from '../prop-types-cc01d273.js';
import 'styled-components';

function Checkbox(_ref) {
  var className = _ref.className,
      onChange = _ref.onChange,
      checked = _ref.checked,
      innerRef = _ref.innerRef,
      _ref$onKeyDown = _ref.onKeyDown,
      _onKeyDown = _ref$onKeyDown === void 0 ? function () {
    return null;
  } : _ref$onKeyDown,
      readOnly = _ref.readOnly,
      value = _ref.value,
      disabled = _ref.disabled,
      style = _ref.style,
      variant = _ref.variant,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      name = _ref.name,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      rest = _objectWithoutProperties(_ref, ["className", "onChange", "checked", "innerRef", "onKeyDown", "readOnly", "value", "disabled", "style", "variant", "tabIndex", "name", "onMouseEnter", "onMouseLeave"]);

  var checkRef = useRef(null);
  return /*#__PURE__*/React.createElement("span", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/React.createElement(CheckMark, _extends({}, rest, {
    ref: innerRef,
    "data-testid": rest['data-testid'] || 'ds-checkbox',
    "aria-checked": checked,
    "aria-disabled": disabled,
    className: "".concat(className, " ").concat(variant || '', " ").concat(disabled ? 'disabled' : ''),
    data: "checkmark",
    onClick: function onClick(e) {
      e.target = checkRef.current;
      if (readOnly) return;
      onChange(e);
    },
    onKeyDown: function onKeyDown(e) {
      e.target = checkRef.current;
      if (readOnly) return;

      if (e.key === 'Enter' || e.keyCode === 32) {
        onChange(e);

        _onKeyDown(e);
      }
    },
    role: "checkbox",
    style: style,
    tabIndex: tabIndex,
    value: value
  }), /*#__PURE__*/React.createElement("input", {
    ref: checkRef,
    checked: checked,
    disabled: disabled,
    name: name,
    readOnly: readOnly,
    style: {
      visibility: 'hidden',
      pointerEvents: 'none'
    },
    type: "checkbox",
    value: value,
    onChange: function onChange() {} // this suppress the warning, we manage onChange on another item level

  })));
}

var DSCheckbox = function DSCheckbox(_ref2) {
  var _ref2$labelText = _ref2.labelText,
      labelText = _ref2$labelText === void 0 ? undefined : _ref2$labelText,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? undefined : _ref2$className,
      _ref2$htmlFor = _ref2.htmlFor,
      htmlFor = _ref2$htmlFor === void 0 ? undefined : _ref2$htmlFor,
      hasError = _ref2.hasError,
      readOnly = _ref2.readOnly,
      disabled = _ref2.disabled,
      checked = _ref2.checked,
      onChange = _ref2.onChange,
      variant = _ref2.variant,
      children = _ref2.children,
      containerProps = _ref2.containerProps,
      innerRef = _ref2.innerRef,
      name = _ref2.name,
      otherProps = _objectWithoutProperties(_ref2, ["labelText", "className", "htmlFor", "hasError", "readOnly", "disabled", "checked", "onChange", "variant", "children", "containerProps", "innerRef", "name"]);

  var _convertPropToCssClas = convertPropToCssClassName('form-element-checkbox', className, {
    hasError: hasError,
    readOnly: readOnly,
    disabled: disabled
  }),
      cssClassName = _convertPropToCssClas.cssClassName,
      classNameElement = _convertPropToCssClas.classNameElement;

  var checkbox = /*#__PURE__*/React.createElement(Checkbox, _extends({}, otherProps, {
    checked: checked,
    className: cx("".concat(classNameElement('input-button'), " checkbox-").concat(String(checked)), className),
    disabled: disabled,
    innerRef: innerRef,
    name: name,
    onChange: onChange,
    readOnly: readOnly,
    variant: variant
  }));
  if (!labelText) return checkbox;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "".concat(cssClassName, " ").concat(variant)
  }, containerProps), /*#__PURE__*/React.createElement("label", {
    className: classNameElement('label'),
    htmlFor: htmlFor
  }, checkbox, /*#__PURE__*/React.createElement("span", {
    className: classNameElement('label-text')
  }, labelText)), children && /*#__PURE__*/React.createElement("div", {
    className: classNameElement('checkbox-children')
  }, children));
};

DSCheckbox.propTypes = checkboxProps;
DSCheckbox.defaultProps = defaultProps;
var CheckboxWithSchema = describe(DSCheckbox);
CheckboxWithSchema.propTypes = checkboxProps;

export default DSCheckbox;
export { CheckboxWithSchema, DSCheckbox };
//# sourceMappingURL=DSCheckbox.js.map
